import { render, staticRenderFns } from "./DashActionButton.vue?vue&type=template&id=e22a0f66&"
import script from "./DashActionButton.vue?vue&type=script&lang=js&"
export * from "./DashActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports